import { Slide } from "@jelly/lesson";

import { task as task02 } from "../../../../../task/course-04/lesson-21/task-02";

const task: Slide = {
  titleHtml:
    "In the low frequency approximation, the shape of the<br>pressure response of a vented box system has the form of a:",
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task02.id,
        },
      },
    },
  },
};

export default task;
